import React from 'react'
import { Box, Flex, Text, Tooltip } from '@chakra-ui/react'
import { Link, useParams } from 'react-router-dom';
import NavItem from '../../Layouts/MainWrapper/NavItem';
import { FiHome, FiBriefcase, FiFilePlus, FiCalendar, FiUsers, FiCode } from 'react-icons/fi';
import { BsGearFill } from 'react-icons/bs';
import { MainWrapperContext } from '../../Layouts/MainWrapper';

export default function AdminRoutes(props) {

    const { tenantID } = useParams<any>();
    const { sidebar } = React.useContext(MainWrapperContext);

    return (
        <Flex
            direction="column"
            as="nav"
            fontSize="sm"
            color="gray.800"
            aria-label="Main Navigation"
            p="4"
        >
            {/* <NavItem icon={ArrowBackIcon} display={{ md: "none" }} onClick={sidebar.onClose}>Back</NavItem> */}
            <Link to={`/${tenantID}/admin`} onClick={sidebar.onClose}>
                <NavItem
                    linkto={`/${tenantID}/admin`}
                    key="Home" icon={FiHome}>
                    Home
                </NavItem>
            </Link>

            <Link to={`/${tenantID}/admin/jobs/all`} onClick={sidebar.onClose}>
                <NavItem
                    linkto={`/${tenantID}/admin/jobs/all`}
                    icon={FiBriefcase}>Jobs </NavItem>
            </Link>

            <Link to={`/${tenantID}/admin/job/add`} onClick={sidebar.onClose}>
                <NavItem
                    linkto={`/${tenantID}/admin/job/add`}
                    icon={FiFilePlus}>Create a new job</NavItem>
            </Link>

            <Link to={`/${tenantID}/admin/calendar`} onClick={sidebar.onClose}>
                <NavItem
                    linkto={`/${tenantID}/admin/calendar`}
                    icon={FiCalendar}>Calendar</NavItem>
            </Link>

            <Link to={`/${tenantID}/admin/team`} onClick={sidebar.onClose}>
                <NavItem
                    linkto={`/${tenantID}/admin/team`}
                    fontWeight="sm"
                    icon={FiUsers}>Team</NavItem>
            </Link>

            <NavItem
                linkto={`/${tenantID}/admin/checklist`}
                icon={FiCode}
                color="gray.400">
                <Tooltip label="Coming soon" bg="green.600">
                    <Box>
                        <Text color="gray.400" >  Embeded Job Form </Text>
                    </Box>
                </Tooltip>
            </NavItem>

            <NavItem
                fontWeight="sm"
                icon={BsGearFill}>Settings</NavItem>

        </Flex>

    )
}
